import React, { useEffect, useState } from 'react'
import { theme, Footer } from '@plurall/elo-beta'
import { useMediaQuery } from 'react-responsive'

import { KEY_STORAGE } from '../../utils'
import styles from './PrivacyFooter.module.scss'

const PrivacyFooter = () => {
  const [openBanner, setOpenBanner] = useState(false)

  const isMobile = useMediaQuery({
    query: theme.elo.breakpoints.mobile,
  })

  const getPrivacyCookie = name => {
    const r = document.cookie.match(`\\b${name}=([^;]*)\\b`)
    return r ? r[1] : undefined
  }

  const setPrivacyCookie = () => {
    document.cookie = `${KEY_STORAGE}=true; expires=${new Date(
      // eslint-disable-next-line no-mixed-operators
      new Date().getTime() + 1000 * 60 * 60 * 24 * 365,
    ).toGMTString()}; path=/; domain=.plurall.net`
  }

  useEffect(() => {
    const hasAcceptTerm = getPrivacyCookie(KEY_STORAGE)
    if (!hasAcceptTerm) {
      setOpenBanner(true)
    }
  }, [isMobile])

  if (!openBanner) {
    return null
  }

  return (
    <div className={`${styles.privacy} ${!isMobile && styles.desktop}`}>
      <Footer
        primaryButtonLabel='Aceitar e fechar'
        onPrimaryButtonClick={() => {
          setPrivacyCookie()
          setOpenBanner(false)
        }}
        primaryButtonDataTestId='primary-button'
        secondaryButtonDataTestId='secondary-button'
        secondaryButtonLabel='Saiba mais'
        onSecondaryButtonClick={() => {
          window.open('https://www.canaldatransparencia.com.br/cogna', '_blank')
        }}
        title='Utilização de Cookies'
        text='Esse site utiliza cookies para oferecer uma melhor experiência de navegação, analisar como você interage em nosso site, otimizar o desempenho e personalizar o conteúdo. Ao utilizar este site, você concorda com o uso de cookies. Saiba mais em nosso'
        linkText='Portal de Privacidade.'
        target='_blank'
        href='https://www.canaldatransparencia.com.br/cogna'
      />
    </div>
  )
}

export default PrivacyFooter
